import React from 'react';
import { Controller, useFormContext, Control } from 'react-hook-form';

type Option = {
    label: string;
    value: number;
};

type FDMRadioGroupInputProps = {
    name: string;
    label: string;
    options: Option[];
    control?: Control<any>;
};

const FDMRadioGroupInput: React.FC<FDMRadioGroupInputProps> = ({
    name,
    label,
    options,
    control: externalControl,
}) => {
    let contextControl: Control<any> | undefined;
    try {
        const methods = useFormContext();
        contextControl = methods.control;
    } catch {
        contextControl = undefined;
    }

    const controlToUse = externalControl ?? contextControl;

    if (!controlToUse) {
        console.warn(
            `[FDMRadioGroupInput] No control found for field '${name}'. Make sure you're using this component inside a FormProvider or passing 'control' manually.`
        );
        return null;
    }

    return (
        <div className="mb-3">
            <label className="form-label fw-bold">{label}</label>

            <Controller
                control={controlToUse}
                name={name}
                render={({ field: { onChange, value } }) => (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
                        {options.map((opt) => (
                            <div
                                className="form-check"
                                style={{ display: 'inline-flex', alignItems: 'center' }}
                                key={opt.value}
                            >
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name={name}
                                    id={`${name}_${opt.value}`}
                                    value={opt.value}
                                    checked={value === opt.value}
                                    onChange={() => onChange(opt.value)}
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor={`${name}_${opt.value}`}
                                    style={{ margin: '10px', fontFamily: 'IRANSans, YekanBakh' }}
                                >
                                    {opt.label}
                                </label>
                            </div>
                        ))}
                    </div>
                )}
            />
        </div>
    );
};

export default FDMRadioGroupInput;
